import { IExecutionOptions } from '@kurtosys/types/query/IExecutionOptions.js';
import { IQueryOptionsUserConfiguration } from '@kurtosys/types/query/options/IQueryOptionsUserConfiguration.js';

import { commonUtils } from '../../common/index.js';
import { queryHelper } from '../queryUtils/index.js';

import { BaseQuery } from './base/BaseQuery.js';

export class UserConfigurationQuery extends BaseQuery<IQueryOptionsUserConfiguration> {
	initialize(executionOptions: IExecutionOptions): void {
		this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsUserConfiguration {
		const { code, codeQuery, key, keyQuery, options = {} } = this.queryOptions;
		return {
			code,
			codeQuery,
			key,
			keyQuery,
			...(options.userConfiguration || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { code, key } = this.options;
		const context = queryHelper.getContext(executionOptions, this.queryOptions);
		const { userConfigurations = {} } = context || {};
		const userConfiguration = userConfigurations[code];
		if (userConfiguration) {
			const value = commonUtils.get(userConfiguration, key);
			return value;
		}
		return undefined;
	}
}
